import React from 'react';
import Guitar from '../guitar(new)/Guitar';
import './ScaleExportTemplate.scss';
import ScaleDegreeChart from '../scale-degree-chart/ScaleDegreeChart';

const ScaleExportTemplate = React.forwardRef(({
  viewerKey,      
  tuning,
  capo,
  watermarkText = 'ezguitarscales.com'
}, ref) => {
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div ref={ref} className="scale-export">
      <div className="scale-export__header">
        <h1 className="scale-export__title">{viewerKey.root} {viewerKey.type}</h1>
        <p className="scale-export__subtitle">Made with EZ Guitar Scales</p>
      </div>

      <div className="scale-export__content">
        <div className="scale-export__guitar">
          <Guitar
            vertical={false}
            tuning={tuning}
            capo={capo}
            activeNotes={viewerKey.notes}
            clickToAddAndRemove={false}
          />
        </div>
        <div className="scale-export__section">
          <ScaleDegreeChart scaleNotes={viewerKey.notes} />
        </div>
      </div>
      <div className="scale-export__footer">
        <p className="scale-export__watermark">{watermarkText}</p>
        <p className="scale-export__date">Generated on {currentDate}</p>
      </div>
    </div>
  );
});

ScaleExportTemplate.displayName = 'ScaleExportTemplate';

export default ScaleExportTemplate;
